<template>
  <div class="recovery-container">
    <div class="recovery-card shadow">
      <h3 class="text-center mb-4 text-body-emphasis">Recuperar Senha</h3>
      <p class="text-body-secondary text-center mb-4">Insira o seu e-mail e enviaremos um link para redefinir a sua senha.</p>

      <!-- Mensagem de sucesso com bordas suaves -->
      <div v-if="mensagemSucesso" class="alert alert-success border-0 shadow-sm">
        <i class="bi bi-check-circle-fill me-2"></i> {{ mensagemSucesso }}
      </div>

      <form @submit.prevent="handleRecovery" v-else>
        <div v-if="erro" class="alert alert-danger border-0 shadow-sm">
          <i class="bi bi-exclamation-triangle-fill me-2"></i> {{ erro }}
        </div>
        <div class="mb-3">
          <label for="email" class="form-label">Email</label>
          <input type="email" class="form-control" id="email" v-model="email" required placeholder="seu@email.com">
        </div>
        <div class="d-grid gap-2 mt-4">
          <button type="submit" class="btn btn-primary" :disabled="isLoading">
            <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Enviar Link de Recuperação
          </button>
          <router-link to="/" class="btn btn-link text-decoration-none">Voltar para o Login</router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import api from '@/services/api' // GUARDIÃO: Importação do interceptor API em vez do axios puro

defineOptions({
  name: 'RecuperarSenha'
})

const email = ref('')
const erro = ref(null)
const isLoading = ref(false)
const mensagemSucesso = ref(null)

const handleRecovery = async () => {
  isLoading.value = true
  erro.value = null

  try {
    // GUARDIÃO: Utilizando a instância configurada da API
    await api.post('/Auth/solicitar-recuperacao', { email: email.value })
    mensagemSucesso.value = 'Se existir uma conta associada a este e-mail, um link de recuperação foi enviado.'
  } catch (error) {
    // Por segurança, não mostramos o erro real. Apenas logamos no console.
    console.error('Erro ao solicitar recuperação:', error)
    // A mensagem de sucesso é mostrada mesmo em caso de erro para não revelar quais e-mails existem no sistema
    mensagemSucesso.value = 'Se existir uma conta associada a este e-mail, um link de recuperação foi enviado.'
  } finally {
    isLoading.value = false
  }
}
</script>

<style scoped>
/* GUARDIÃO: Variáveis CSS do Bootstrap 5 para suportar Dark Mode automaticamente */
.recovery-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: var(--bs-tertiary-bg);
  transition: background-color 0.3s ease;
}

.recovery-card {
  width: 100%;
  max-width: 450px;
  padding: 2.5rem;
  background-color: var(--bs-body-bg);
  color: var(--bs-body-color);
  border: 1px solid var(--bs-border-color-translucent);
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  transition: background-color 0.3s ease, border-color 0.3s ease;
}
</style>
